import { useCallback, useEffect, useRef, useState, createContext } from "react";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from "react-toasts";
import { dataQueryStatus } from "utils";
import ToastContent from "../content/ToastContent";
import PermissionDeniedToast from "../content/PermissionDeniedToast";
import "./ToastContextProvider.scss";

export const ToastContext = createContext();
export const PermissionDeniedToastContext = createContext();

const PERMISSION_DENIED_DURATION_MS = 4000;

const ToastContextProvider = ({ children }) => {
    const [permissionDeniedVisible, setPermissionDeniedVisible] = useState(false);
    const permissionDeniedTimerRef = useRef(null);

    const clearPermissionDeniedTimer = useCallback(() => {
        if (permissionDeniedTimerRef.current) {
            clearTimeout(permissionDeniedTimerRef.current);
            permissionDeniedTimerRef.current = null;
        }
    }, []);

    const dismissPermissionDenied = useCallback(() => {
        clearPermissionDeniedTimer();
        setPermissionDeniedVisible(false);
    }, [clearPermissionDeniedTimer]);

    const showPermissionDenied = useCallback(() => {
        clearPermissionDeniedTimer();
        setPermissionDeniedVisible(true);

        permissionDeniedTimerRef.current = setTimeout(() => {
            setPermissionDeniedVisible(false);
            permissionDeniedTimerRef.current = null;
        }, PERMISSION_DENIED_DURATION_MS);
    }, [clearPermissionDeniedTimer]);

    useEffect(() => {
        return () => clearPermissionDeniedTimer();
    }, [clearPermissionDeniedTimer]);

    const toastMessage = useCallback(function (message, type) {
        let messageValueType = typeof message;
        if (messageValueType === "array") {
            message = message[0];
        }

        if (type === dataQueryStatus.ERROR) {
            ToastsStore.error(
                <ToastContent message={message} isError={true} />,
                2000
            );
        } else {
            ToastsStore.success(
                <ToastContent message={message} isError={false} />,
                2000
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ToastContext.Provider value={toastMessage}>
            <PermissionDeniedToastContext.Provider value={showPermissionDenied}>
                {children}
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_CENTER}
                    lightBackground
                />
                <PermissionDeniedToast
                    visible={permissionDeniedVisible}
                    onDismiss={dismissPermissionDenied}
                />
            </PermissionDeniedToastContext.Provider>
        </ToastContext.Provider>
    );
};

export default ToastContextProvider;
